import { Button, Form, Checkbox, message, Modal, Tabs } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { errorCatch, GET, GETWITH, JSX, JSXMap, POST, QueryParam, QueryParams, READWITH, useAuth } from 'fennec-ui';

import confirmKey from '../../components/ConfirmKeyModal';
import Icofont from 'react-icofont';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import locale from 'antd/es/date-picker/locale/ru_RU';
import { DatePicker, Space } from 'antd';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');


const { RangePicker } = DatePicker;

var _ = require('lodash');



function getCurrencyValue(value, color) {
    if (!value) {
        return (<span style={{ color: "grey" }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (color) {
        return (<span style={{ color: color }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (value >= 0) {
        return (<span style={{ color: "rgb(63, 134, 0)" }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (value < 0) {
        return (<span style={{ color: "red" }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
}
function getCurrencyAbsValue(value, color) {
    if (!value) {
        return (<span>
            {/* {Math.abs(Number(0)).toLocaleString('ru', { minimumFractionDigits: 2 })} руб. */}
        </span>)
    }
    if (color) {
        return (<span style={{ color: color }}>
            {Math.abs(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (value >= 0) {
        return (<span style={{ color: "rgb(63, 134, 0)" }}>
            {Math.abs(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (value < 0) {
        return (<span style={{ color: "red" }}>
            {Math.abs(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
}

function AkkauntRow({ item, idx, account }) {
    const [collapsed, setCollapsed] = useState(true);
    const auth = useAuth()

    const isPlus = (item?.dvizhenieDeneg?.ukhodID != account.ID) && (!item?.dvizhenieDeneg?.ukhodID);
    const isMinus = (item?.dvizhenieDeneg?.prikhodID != account.ID) && (!item?.dvizhenieDeneg?.ukhodID);
    const rowColor = (isPlus) ? "bg-green" : (isMinus) ? "bg-red" : "bg-grey";

    // console.log(item);
    // useEffect(() => {
    //     if (!collapsed) {
    //         READWITH(auth, item.dvizhenieDeneg.osnovanie.ownerType, [
    //             QueryParam("w-ID", item.dvizhenieDeneg.osnovanie.ownerID)
    //         ], ({ data }) => {
    //             console.log(data);
    //         }, errorCatch)
    //     }
    // }, [collapsed])
    return (<React.Fragment key={idx}>
        <tr key={idx} className={'pointer'} onClick={() => {
            setCollapsed(o => !o);
        }}>
            <td className={`fill`}><div className={`bg ${rowColor}`} style={{ minWidth: "25px", maxWidth: "25px" }}>
                {(collapsed) && <i className="fa fa-plus-square-o"></i>}
                {(!collapsed) && <i className="fa fa-minus-square-o"></i>}
            </div></td>
            <td className={`fill`}>
                <div className={`bg ${rowColor}`}>
                    <div>{dayjs(item?.dataVremya).format("DD.MM.YYYY HH:mm:ss")}</div>
                    {/* <div style={{
                        fontStyle: "italic",
                        color: "rgba(0, 0, 0, 0.45)",
                    }}>№{item?.Oplata?.zakaz?.nomerZakaza}</div> */}
                </div>
            </td>
            <td className={`fill`}><div className={`bg ${rowColor}`}>{getCurrencyValue(item?.summaDoOperatsii)}</div></td>
            <td className={`fill`}><div className={`bg ${rowColor}`}>{getCurrencyValue(item?.summaOperatsii)}</div></td>
            <td className={`fill`}><div className={`bg ${rowColor}`}>{getCurrencyValue(item?.summaPosleOperatsii)}</div></td>
        </tr>
        {(!collapsed) && <tr>
            <td colSpan={5} className={`fill`}>
                <div className="bg bg-orange" style={{ textAlign: "left", marginLeft: "25px", textWrap: "initial" }}>
                    <div style={{ fontWeight: "300", fontSize: "12px", fontStyle: "italic" }}>
                        <span style={{ fontWeight: "400", fontSize: "12px" }}>
                            
                                {(!item?.dvizhenieDeneg?.ukhodID && item?.dvizhenieDeneg?.prikhodID) && <span>Зачисление денежных средств {(item?.dvizhenieDeneg?.osnovanie?.ownerType == 'ekvairing') && <span>(эквайринг)</span>}</span>}
                                {(item?.dvizhenieDeneg?.ukhodID && !item?.dvizhenieDeneg?.prikhodID) && <span>Вывод денежных средств</span>}
                                

                                {(item?.dvizhenieDeneg?.ukhodID && item?.dvizhenieDeneg?.prikhodID) && <span>
                                    <span>№{item?.dvizhenieDeneg?.ukhodNomer} {item?.dvizhenieDeneg?.ukhodVladelets}</span>    
                                    <Icofont icon="long-arrow-right" />
                                    <span>№{item?.dvizhenieDeneg?.prikhodNomer} {item?.dvizhenieDeneg?.prikhodVladelets}</span>
                                </span>}
                        </span>
                    </div>
                    <div style={{ fontWeight: "300" }}>
                        {item?.dvizhenieDeneg?.opisanie}
                    </div>
                    <div style={{ fontWeight: "300" }}>
                        {item?.dvizhenieDeneg?.comment}
                    </div>
                </div>
            </td>
        </tr>}
    </React.Fragment>)
}

export default function OstatkiPoSchetu(props) {
    const { auth, object, location } = props;

    const [akkauntOstatki, setAkkauntOstatki] = useState(undefined);
    let summaOperatsiy = _.reduce(akkauntOstatki?.ostatkiPoOperatsiyamAkkaunt, (a, p) => a + p?.summaOperatsii, 0);
    const defStart = dayjs().subtract(3, 'month');
    const defEnd = dayjs().add(1, 'day');
    useEffect(() => {
        GETWITH(auth, `/api/akkaunti/ostatki-po-operatsiyam${(location)?"/"+location:""}`, [
            QueryParam("akkaunt", object?.ID),
            QueryParam("datestart", defStart.format('YYYY-MM-DD')),
            QueryParam("dateend", defEnd.format('YYYY-MM-DD'))
        ], ({ data }) => {
            setAkkauntOstatki(data);
        }, errorCatch);
    }, [])


    return (
        <>
            {props.subheader}
            <div style={{ paddingBottom: "15px", display: "flex", justifyContent: "right" }}>
                <RangePicker
                    locale={locale}
                    format="YYYY-MM-DD"
                    defaultValue={[defStart, defEnd]}
                    onChange={(value) => {
                        GETWITH(auth, `/api/akkaunti/ostatki-po-operatsiyam${(location)?"/"+location:""}`, [
                            QueryParam("akkaunt", object?.ID),
                            QueryParam("datestart", value[0].format('YYYY-MM-DD')),
                            QueryParam("dateend", value[1].format('YYYY-MM-DD'))
                        ], ({ data }) => {
                            setAkkauntOstatki(data);
                        }, errorCatch);
                    }}
                />
            </div>
            {object && <div className='scrollable'>
                <table className="table" style={{ fontSize: "13px" }}>
                    <thead>
                        <tr>
                            <th className={`wrap`} style={{ minWidth: "25px", maxWidth: "25px", width: "25px" }}></th>
                            <th className={`wrap`} style={{ minWidth: "260px", maxWidth: "260px" }}><div className='bg bg-grey dark-1'>Дата/время операции</div></th>
                            <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Остаток до операции</div></th>
                            <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Сумма операции</div></th>
                            <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Остаток после операции</div></th>
                        </tr>
                        <tr className="tr-rounded">
                            <th></th>
                            <th className={`wrap`}><div className="bg bg-blue"><div style={{
                                fontStyle: "italic",
                                color: "rgba(0, 0, 0, 0.45)",
                            }}>№{akkauntOstatki?.nomerAkkaunta}</div></div></th>
                            <th className={`wrap`}><div className="bg bg-blue"></div></th>
                            <th className={`wrap`}><div className="bg bg-blue">{getCurrencyValue(summaOperatsiy)}</div></th>
                            <th className={`wrap`}><div className="bg bg-blue"></div></th>
                        </tr>
                    </thead>
                    <tbody style={{ fontSize: "12px" }}>
                        {JSXMap(akkauntOstatki?.ostatkiPoOperatsiyamAkkaunt, (o, oidx) => {
                            return (<AkkauntRow key={oidx} item={o} idx={oidx} account={object} />)
                        })}
                    </tbody>
                </table>
            </div>}
        </>
    );
}
